export enum Direction {
  Up = "up",
  Down = "down",
  Left = "left",
  Right = "right",
}

export const ALL_DIRECTIONS = [Direction.Up, Direction.Left, Direction.Right, Direction.Down];
